(ns frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.fund-overview
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]))

(defn fund-overview-page
  [data]
  (let [{:keys [fund-overview]} data]
    (page/page
     (page/page-title-with-line {:fund-name (:fund-name data) :page-title "Overview" :toc-item true})
     (column/half-columns
      (card
       nil
       (card
        ""
        (block-table-pdf/table (:fund-overview-1 fund-overview))))
      (card
       nil
       (card
        ""
        (block-table-pdf/table (:fund-overview-2 fund-overview))))
     ))))
